import {ResizableTableColumns, ResizableConstants, ResizableEventData} from '@validide/resizable-table-columns'

class RoxCols extends ResizableTableColumns {
}

RoxCols.prototype.handlePointerDown = function (event) {
  this.handlePointerUp();

  let target = event ? event.target : null;
  if (target == null)
    return;

  if(target.nodeName === 'SPAN' && target.classList.contains('drag-icon')){
    target = target.parentElement
  }

  if (target.nodeName !== 'DIV' || !target.classList.contains(ResizableConstants.classes.handle))
    return;

  if (typeof event.button === 'number' && event.button !== 0)
    return; // this is not a left click

  const dragHandler = target;
  const gripIndex = this.getDragHandlers().indexOf(dragHandler);
  const resizableHeaders = this.getResizableHeaders();
  if (gripIndex >= resizableHeaders.length)
    return;

  const millisecondsNow = (new Date()).getTime();
  const isDoubleClick = (millisecondsNow - this.lastPointerDown) < this.options.doubleClickDelay
  const column = resizableHeaders[gripIndex]
  const columnWidth = column.offsetWidth

  const widths = {
    column: columnWidth,
    table: this.table.offsetWidth
  };
  const eventData = new ResizableEventData(column, dragHandler);
  eventData.pointer = {
    x: ResizableTableColumns.getPointerX(event),
    isDoubleClick: isDoubleClick
  };
  eventData.originalWidths = widths;
  eventData.newWidths = widths;

  this.detachHandlers(); //make sure we do not have extra handlers
  this.attachHandlers();

  this.table.classList.add(ResizableConstants.classes.tableResizing);
  this.wrapper.classList.add(ResizableConstants.classes.tableResizing);
  dragHandler.classList.add(ResizableConstants.classes.columnResizing);
  column.classList.add(ResizableConstants.classes.columnResizing);

  this.lastPointerDown = millisecondsNow;
  this.eventData = eventData;

  var eventToDispatch = new CustomEvent(ResizableConstants.events.eventResizeStart, {
    detail: {
      column: column,
      columnWidth: columnWidth,
      table: this.table,
      tableWidth: this.table.clientWidth
    }
  });
  this.table.dispatchEvent(eventToDispatch);
  event.preventDefault();
}

RoxCols.prototype.handlePointerMove = function (event) {
  ResizableTableColumns.prototype.handlePointerMove.call(this, event)
  this.syncHandleWidths()
  document.body.dispatchEvent(new CustomEvent('table_resized'))
  _vapp.$root.$emit('table_resized')
}

RoxCols.prototype.createDragHandles = function () {
  // return ResizableTableColumns.prototype.createDragHandles.call(this)

  if (this.dragHandlesContainer != null)
    throw 'Drag handlers already created. Call <destroyDragHandles> if you wish to recreate them';


  this.dragHandlesContainer = this.ownerDocument.createElement('div');
  this.wrapper?.insertBefore(this.dragHandlesContainer, this.table);
  this.dragHandlesContainer.classList.add(ResizableConstants.classes.handleContainer);

  this.getResizableHeaders()
      .forEach(() => {
        const handler = this.ownerDocument.createElement('div');
        handler.classList.add(...[ResizableConstants.classes.handle]);
        const fac = document.createElement('span')
        fac.classList.add(...['fa', 'fa-arrows-alt', 'px-1', 'drag-icon', 'text-gray-500',])
        handler.appendChild(fac)
        this.dragHandlesContainer?.appendChild(handler);
      });

  ResizableConstants.events.pointerDown
      .forEach((evt, evtIdx) => {
        this.dragHandlesContainer?.addEventListener(evt, this.onPointerDownRef, false);
      });
}

export default RoxCols